<div *ngIf="booking">
  <div [ngClass]="textSize" class="fw-bold" *ngIf="template && booking.guestsOfHonor">
    {{displayText}}
  </div>
  <ua-party-time *ngIf="showTime" [booking]="booking" [color]="'primary'"></ua-party-time>
</div>
